"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledWrapper = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "IconBubblestyles__StyledWrapper",
  componentId: "sc-1bh6nvp-0"
})(["", ";"], _button.iconBubble);
exports.StyledWrapper = StyledWrapper;